import { render, staticRenderFns } from "./RecordingCoachPage.vue?vue&type=template&id=1cdecbab&scoped=true"
import script from "./RecordingCoachPage.vue?vue&type=script&lang=js"
export * from "./RecordingCoachPage.vue?vue&type=script&lang=js"
import style0 from "./RecordingCoachPage.vue?vue&type=style&index=0&id=1cdecbab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdecbab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/francescobarbieri/Dev/brain/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cdecbab')) {
      api.createRecord('1cdecbab', component.options)
    } else {
      api.reload('1cdecbab', component.options)
    }
    module.hot.accept("./RecordingCoachPage.vue?vue&type=template&id=1cdecbab&scoped=true", function () {
      api.rerender('1cdecbab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/admin-panel/components/recording-coach/RecordingCoachPage.vue"
export default component.exports